export default __webpack_public_path__ + "static/media/Music_All_W.1aa0b131.png";